import { toast } from "react-toastify";
import { apiV1 } from "../lib/axios";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const sendTedFitBank = async (data) => {
  try {
    const response = await apiV1.post("/ted/send", data);
    return response; 
  } catch (err) {
    const message = getApiErrorMessage(err, "Ocorreu um erro ao enviar a TED. Tente novamente mais tarde.");
    toast.error(message);
    return { error: true, message };
  }
};

export const sendMfaTedFitBank = async () => {
  await apiV1.post("/mfa")
    .catch((err) => {
      toast.error(getApiErrorMessage(err, "Erro ao enviar o MFA"));
      return;
    });
  return
}